import { createWhatsapp } from './whatsapp';
import { WhatsappService } from './whatsappService';
import { EventSourceManager } from '@wkda/autopricing-service';
export function create(apiUrl, _ref) {
  let {
    logger,
    apmLogger,
    config
  } = _ref;
  const whatsappService = new WhatsappService(new EventSourceManager('whatsapp-sse'), apiUrl);
  return createWhatsapp({
    whatsappService,
    logger,
    apmLogger,
    config
  });
}